(() => {
  const fr = {
    brand: 'Toiles d’artiste, panneaux et châssis fabriqués au Canada pour les artistes et les professionnels.',
    explore: 'Découvrir',
    contact: 'Contact',
    newsletterTitle: 'Notes d’atelier',
    newsletterText: 'Nous fabriquons des toiles plus souvent que nous envoyons des courriels. Vous aurez rarement de nos nouvelles, et seulement quand ça en vaut la peine.',
    newsletterAdditional: 'Vous pouvez vous désabonner en tout temps. Nous respectons votre vie privée et ne partageons jamais vos renseignements.'
  };

  function isFrench() {
    const htmlLang = (document.documentElement.lang || '').toLowerCase();
    if (htmlLang.startsWith('fr')) return true;

    const localeInput = document.querySelector('input[name="locale_code"]');
    return (localeInput?.value || '').toLowerCase().startsWith('fr');
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach((el) => {
      el.textContent = value;
    });
  }

  function translateFooter(root = document) {
    if (!isFrench()) return;

    root.querySelectorAll('.footer').forEach((footer) => {
      setText(footer, '.footer-block--logo .footer-block__text', fr.brand);
      setText(footer, '.accordion .footer-block__heading', fr.explore);
      setText(footer, '.footer-block--menu:not(.contacts) > .footer-block__heading', fr.explore);
      setText(footer, '.contacts__text', fr.contact);
      setText(footer, '.newsletter__title', fr.newsletterTitle);
      setText(footer, '.newsletter__text:not(.newsletter__text--additional)', fr.newsletterText);
      setText(footer, '.newsletter__text--additional', fr.newsletterAdditional);
    });
  }

  function run(root = document) {
    translateFooter(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
